(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pd26-panier-barre"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.pd26PanierBarre) return;
    var SEUIL = 9900;
    function euros(c) { return (c / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' }); }
    window.pd26PanierBarre = function (cart) {
      if (!cart || cart.items_subtotal_price == null) return;
      document.querySelectorAll('[data-p26-pb]').forEach(function (b) {
        b.hidden = !cart.item_count;
        var t = b.querySelector('[data-p26-pb-seuil]');
        if (!t || cart.currency !== 'EUR') return;
        var reste = SEUIL - cart.items_subtotal_price;
        var html = reste > 0 ? 'Plus que <strong>' + euros(reste) + '</strong> pour la livraison offerte.' : '<strong>Livraison offerte.</strong>';
        if (t.innerHTML !== html) t.innerHTML = html;
        var j = b.querySelector('[data-p26-pb-jauge]');
        if (j) j.style.width = Math.min(100, Math.round(cart.items_subtotal_price * 100 / SEUIL)) + '%';
        b.classList.toggle('est-offerte', reste <= 0);
      });
    };
    function rafraichir() {
      var racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(racine + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(window.pd26PanierBarre)
        .catch(function () {});
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-ouvre="minipanier"]')) rafraichir();
    });
    document.addEventListener('cart:update', function (e) {
      var c = e.detail && e.detail.resource;
      if (c && c.items_subtotal_price != null) window.pd26PanierBarre(c); else rafraichir();
    });
    function surveiller() {
      var total = document.getElementById('p26-mp-total');
      if (total && window.MutationObserver) new MutationObserver(rafraichir).observe(total, { childList: true, characterData: true, subtree: true });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', surveiller); else surveiller();
  })();
  } catch(e) { console.error(e); }
})();

})();
